import type { CSSProperties } from "react";

export const cellBorder: CSSProperties = {
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
};

export const trackingPill: CSSProperties = {
    fontFamily: "monospace", fontSize: "12px", background: "#f3f4f6",
    padding: "3px 8px", borderRadius: "6px", color: "#374151",
    display: "inline-block", maxWidth: "100%", overflow: "hidden",
    textOverflow: "ellipsis", whiteSpace: "nowrap", verticalAlign: "middle",
};

export const channelPill: CSSProperties = {
    display: "inline-flex", alignItems: "center", padding: "4px 10px",
    borderRadius: "20px", fontSize: "12px", fontWeight: 600,
    background: "#eff6ff", color: "#2563eb", border: "1px solid #dce7ff",
    textTransform: "capitalize",
};

export const orgPill: CSSProperties = {
    padding: "5px 8px", borderRadius: "20px", fontSize: "12px",
    background: "#fefce8", border: "1px solid #61351b4a", color: "#92400e",
    fontWeight: 600, display: "inline-block", maxWidth: "100%",
    overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
    verticalAlign: "middle",
};

// Error message: one line, ellipsis, full text via title on hover.
export const errorText: CSSProperties = {
    fontSize: "13px", color: "#111827", fontWeight: 500,
    overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
    display: "block", minWidth: 0,
};

export const pageBtn = (active: boolean): CSSProperties => ({
    padding: "6px 11px", borderRadius: "6px", fontSize: "13px",
    fontWeight: active ? 700 : 400,
    border: active ? "none" : "1px solid #e5e7eb",
    background: active ? "#1a1a2e" : "#fff",
    color: active ? "#fff" : "#374151",
    cursor: "pointer", minWidth: "32px",
});

export const navBtn = (enabled: boolean): CSSProperties => ({
    padding: "6px 10px", borderRadius: "6px", border: "1px solid #e5e7eb",
    background: enabled ? "#fff" : "#f9fafb",
    cursor: enabled ? "pointer" : "default",
    color: enabled ? "#374151" : "#d1d5db",
    display: "flex", alignItems: "center",
});